import * as React from 'react';

function SvgFooterMobileIcon(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 16" {...props}>
    <path
      stroke="#363D43"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M1 13.963V2.037C1 1.415 1.38 1 1.952 1h6.096C8.619 1 9 1.415 9 2.037v11.926C9 14.585 8.619 15 8.048 15H1.952C1.381 15 1 14.585 1 13.963M1 11.267h8M4.333 13.03h1.429M4.904 2.763h.286"
    />
  </svg>)
}
export default SvgFooterMobileIcon;
